import { useState } from 'react';
import MobileButtons from '../Content/HealthMonitor/MobileButtons';
import MobileMenu from '../Content/HealthMonitor/MobileMenu';
import SearchBar from '../Content/HealthMonitor/SearchBar/SearchBar';
import { DateFilter } from './DatePicker/DatePicker';
import { MOBILE_MENU_DISAPPEAR_TIMEOUT } from '../../../constant/constants';
import { useAllFilters } from '../../../hook/useAllFilters';
import { useHeaderConfig } from '../../../hook/useHeaderConfig';
import { useAppSelector } from '../../../hook/useAppSelector';
import CustomFilter from './Filters/CustomFilter';
import GeoSummary from './GeoSummary/GeoSummary';
import { useMenus } from '../../../hook/useMenus';
import { SearchExecutionMode } from '../../../enum/SearchExecutionMode';

interface Props {
  title: string;
}

const MobileHeader: React.FC<Props> = ({ title }) => {
  const filterType = useAppSelector((state) => state.globalFilters.filterType);

  const [shouldShowSearchBar, setShouldShowSearchBar] = useState(false);
  const [shouldShowMenu, setShouldShowMenu] = useState(false);
  const [isMenuButtonActive, setIsMenuButtonActive] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);

  const { handleApplyAllFilters } = useAllFilters();
  const menus = useMenus();
  const headerConfig = useHeaderConfig(menus);

  const onMenuButtonClick = () => {
    setIsMenuButtonActive((prev) => !prev);
    setAnimateIn(false);

    if (isMenuButtonActive) {
      setTimeout(() => {
        setShouldShowMenu(false);
      }, MOBILE_MENU_DISAPPEAR_TIMEOUT);
    } else {
      setShouldShowMenu(true);
    }
  };

  return (
    <div className="content">
      <div className="health_monitor">
        {shouldShowMenu && (
          <MobileMenu
            animateIn={animateIn}
            setAnimateIn={setAnimateIn}
            isMenuButtonActive={isMenuButtonActive}
            onMenuButtonClick={onMenuButtonClick}
          />
        )}

        <div className="mobile_header">
          {headerConfig.datePicker && <DateFilter onSearch={handleApplyAllFilters} />}

          {filterType && (
            <>
              <CustomFilter />
              {headerConfig.sumBy && <GeoSummary />}
            </>
          )}

          <MobileButtons
            setIsMenuButtonActive={setIsMenuButtonActive}
            isMenuButtonActive={isMenuButtonActive}
            onMenuButtonClick={onMenuButtonClick}
            setShouldShowSearchBar={setShouldShowSearchBar}
            setShouldShowMenu={setShouldShowMenu}
            setAnimateIn={setAnimateIn}
          />
        </div>

        {shouldShowSearchBar && (
          <SearchBar
            shouldAutocompleteSearch={true}
            hasSearchColumnDropdownPicker={headerConfig.search ? false : true}
            mode={SearchExecutionMode.LIVE}
          />
        )}
      </div>
    </div>
  );
};

export default MobileHeader;
